// src/utils/formatters.ts

export function formatPrice(value: number | null | undefined, opts?: { emptyLabel?: string }) {
  if (value == null || !Number.isFinite(value) || value <= 0) return opts?.emptyLabel ?? "Consultar";

  // tu formato actual:
  return value.toLocaleString("es-AR", { style: "currency", currency: "ARS", maximumFractionDigits: 0 });
}
